import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useCustomers } from "@/customers/useCustomers";

interface CustomerSelectorProps {
  selectedCustomerId?: string;
  onCustomerChange: (customerId: string) => void;
}

export function CustomerSelector({ selectedCustomerId, onCustomerChange }: CustomerSelectorProps) {
  const { customers } = useCustomers();

  return (
    <div className="space-y-2">
      <Label>Customer</Label>
      <Select value={selectedCustomerId || ""} onValueChange={onCustomerChange}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Select a customer" />
        </SelectTrigger>
        <SelectContent>
          <ScrollArea className="h-[200px]">
            {customers?.map((c) => (
              <SelectItem key={c.id} value={c.id}>
                {c.label}
              </SelectItem>
            ))}
          </ScrollArea>
        </SelectContent>
      </Select>
    </div>
  );
}
